export const themeData = {
	fod: {
		logo: '/images/splash/logo-black.png',
		privacyPolicyLink: 'https://fod.fleetondemand.com/media-file/9230809/stream/',
		webLink: 'https://www.fleetondemand.com/',
		webLinkText: 'www.fleetondemand.com',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Fleetondemand',
		bannerColour: '#3f3f3f',
		loginStyles: {},
		displayLoginWelcomeText: true,
	},
	['fod-sui']: {
		logo: '/images/splash/logo-black.png',
		privacyPolicyLink: 'https://fod.fleetondemand.com/media-file/9230809/stream/',
		webLink: 'https://www.fleetondemand.com/',
		webLinkText: 'www.fleetondemand.com',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Fleetondemand',
		bannerColour: '#3f3f3f',
		displayLoginWelcomeText: true,
	},
	fleetoperations: {
		logo: '/images/themes/fleetoperations/dual-fo-traxall-logo.png',
		privacyPolicyLink: 'https://www.fleetoperations.co.uk/privacy-policy/',
		webLink: 'https://www.fleetoperations.co.uk/',
		webLinkText: 'www.fleetoperations.co.uk',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Fleet Operations',
		bannerColour: '#2cacde',
		logoStyles: {
			margin: 'auto',
		},
		subHeadingStyles: {
			textAlign: 'center',
		},
		displayLoginWelcomeText: true,
	},
	traxall: {
		logo: '/images/themes/fleetoperations/dual-logo.jpg',
		privacyPolicyLink: 'https://www.traxallinternational.com/privacy-policy/',
		webLink: 'https://www.traxallinternational.com/',
		webLinkText: 'www.traxallinternational.com',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'TraXall',
		bannerColour: '#2cacde',
		displayLoginWelcomeText: true,
	},
	compello: {
		logo: '/images/themes/compello/compello-new-logo.png',
		privacyPolicyLink: 'https://compello.uk.com/cookie-and-privacy-policy/',
		webLink: 'https://compelloautomotive.uk.com/',
		webLinkText: 'www.compelloautomotive.uk.com',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Compello',
		bannerColour: '#41868a',
		displayLoginWelcomeText: true,
	},
	fulcrum: {
		logo: '/images/themes/fulcrum/fulcrum-logo.jpg',
		privacyPolicyLink: 'https://www.fulcrum-automotive.co.uk/ ',
		webLink: 'https://www.fulcrum-automotive.co.uk/',
		webLinkText: 'Fulcrum Automotive',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Fulcrum Automotive',
		bannerColour: '#080E10',
		displayLoginWelcomeText: true,
	},
	cbvc: {
		logo: '/images/themes/cbvc/cbvc-logo.png',
		privacyPolicyLink: 'https://www.cbvcvehiclemanagement.co.uk/privacy-policy/',
		webLink: 'https://www.cbvcvehiclemanagement.co.uk/',
		webLinkText: 'CBVC',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'CBVC',
		bannerColour: '#3C3C3B',
		displayLoginWelcomeText: true,
	},
	rac: {
		logo: '/images/themes/rac/rac-logo.png',
		privacyPolicyLink: 'https://www.rac.co.uk/legal-information/privacy-policy',
		webLink: 'https://www.rac.co.uk/',
		webLinkText: 'RAC',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'RAC',
		bannerColour: '#f95108',
		displayLoginWelcomeText: true,
	},
	driveway: {
		logo: '/images/themes/driveway/logo.png',
		privacyPolicyLink: 'https://www.drivewayvehiclesolutions.co.uk/legal/privacy-notice/',
		webLink: 'https://www.drivewayvehiclesolutions.co.uk/',
		webLinkText: 'Driveway Vehicle Solutions',
		footerLogo: {
			display: false,
			image: '',
		},
		themeText: 'Driveway Vehicle Solutions',
		bannerColour: '#1451B5',
		displayLoginWelcomeText: true,
	},
	gts: {
		logo: '/images/themes/gts/gts-logo.png',
		privacyPolicyLink: 'https://gts.fleetondemand.com/media-file/9230809/stream/',
		webLink: 'https://www.fleetondemand.com/',
		webLinkText: 'www.fleetondemand.com',
		footerLogo: {
			display: true,
			image: '/images/themes/gts/logo-footer.png',
		},
		themeText: 'GT Suite',
		bannerColour: '#1A432E',
		displayLoginWelcomeText: true,
	},
	wincanton: {
		logo: '/images/themes/wincanton/logo.png',
		privacyPolicyLink: 'https://www.wincanton.co.uk/privacy-notice/ ',
		webLink: 'https://www.wincanton.co.uk/',
		webLinkText: 'www.wincanton.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/wincanton/logo-footer.png',
		},
		themeText: 'Wincanton',
		bannerColour: '#011E41',
		displayLoginWelcomeText: true,
	},
	altrad: {
		logo: '/images/themes/altrad/logo.png',
		privacyPolicyLink: 'https://uk.altradservices.com/privacy/',
		webLink: 'https://uk.altradservices.com/ ',
		webLinkText: 'www.altradservices.com',
		footerLogo: {
			display: true,
			image: '/images/themes/altrad/logo.png',
		},
		themeText: 'Altrad Services',
		bannerColour: '#e30413',
		displayLoginWelcomeText: true,
	},
	vavoom: {
		logo: '/images/themes/vavoom/logo.png',
		privacyPolicyLink: 'https://www.vavoomleasing.com/legal/privacy-policy',
		webLink: 'https://www.vavoomleasing.com/',
		webLinkText: 'www.vavoomleasing.com',
		footerLogo: {
			display: true,
			image: '/images/themes/vavoom/logo.png',
		},
		themeText: 'Vavoom Vehicle Leasing',
		bannerColour: '#2544d7',
		displayLoginWelcomeText: true,
	},
	spiredrive: {
		logo: '/images/themes/spiredrive/logo.png',
		privacyPolicyLink: 'https://spiredrive.co.uk/media/2019999/privacy-policy-spiredrive-230518.pdf',
		webLink: 'https://spiredrive.co.uk/ ',
		webLinkText: 'www.spiredrive.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/spiredrive/logo.png',
		},
		themeText: 'Spiredrive',
		bannerColour: '#fa8d29',
		displayLoginWelcomeText: true,
	},
	bbfleetservices: {
		logo: '/images/themes/bbfleetservices/logo.png',
		privacyPolicyLink: 'https://www.balfourbeatty.com/privacy/',
		webLink: 'https://www.balfourbeatty.com/',
		webLinkText: 'www.balfourbeatty.com',
		footerLogo: {
			display: true,
			image: '/images/themes/bbfleetservices/logo-footer.png',
		},
		themeText: 'Balfour Beatty Fleet Services',
		bannerColour: '#0067A5',
		displayLoginWelcomeText: true,
	},
	octopus: {
		logo: '/images/themes/octopus/logo.png',
		privacyPolicyLink: 'https://octopusev.com/privacy-policy',
		webLink: 'https://octopusev.com/',
		webLinkText: 'www.octopusev.com',
		footerLogo: {
			display: true,
			image: '/images/themes/octopus/logo-footer.png',
		},
		themeText: 'Octopus EV',
		bannerColour: '#100030',
		displayLoginWelcomeText: true,
	},
	dreamlease: {
		logo: '/images/themes/dreamlease/logo.png',
		privacyPolicyLink: 'https://dreamlease.co.uk/privacy-policy/ ',
		webLink: 'https://dreamlease.co.uk/',
		webLinkText: 'www.dreamlease.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/dreamlease/logo-footer.png',
		},
		themeText: 'Dreamlease',
		bannerColour: '#E30613',
		displayLoginWelcomeText: true,
	},
	autohorn: {
		logo: '/images/themes/autohorn/logo.png',
		privacyPolicyLink: 'https://autohornfleetservices.co.uk/privacy-policy/  ',
		webLink: 'https://autohornfleetservices.co.uk/ ',
		webLinkText: 'www.autohornfleetservices.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/autohorn/logo-footer.png',
		},
		themeText: 'Autohorn',
		bannerColour: '#00703D',
		displayLoginWelcomeText: true,
	},
	grosvenor: {
		logo: '/images/themes/grosvenor/logo.svg',
		privacyPolicyLink: 'https://grosvenor-leasing.co.uk/privacy-policy/',
		webLink: 'https://grosvenor-leasing.co.uk/',
		webLinkText: 'www.grosvenor-leasing.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/grosvenor/logo-footer.png',
		},
		themeText: 'Grosvenor',
		bannerColour: '#002C3A',
		displayLoginWelcomeText: true,
	},
	justfleets: {
		logo: '/images/themes/justfleets/logo.png',
		webLink: 'https://justfleets.co.uk/  ',
		webLinkText: 'www.justfleets.co.uk',
		footerLogo: {
			display: true,
			image: '/images/splash/FOD-Logo.png',
		},
		themeText: 'Just Fleets',
		bannerColour: '#812125',
		displayLoginWelcomeText: true,
	},
	evpsolutions: {
		logo: '/images/themes/evpsolutions/logo.jpg',
		webLink: 'https://evpsolutions.co.uk/ ',
		webLinkText: 'www.evpsolutions.co.uk',
		footerLogo: {
			display: true,
			image: '/images/themes/evpsolutions/logo-footer.png',
		},
		themeText: 'EVP Solutions',
		bannerColour: '#118C4E',
		displayLoginWelcomeText: true,
	},
	jct: {
		logo: '/images/themes/jct/logo.png',
		webLink: 'https://jct600vehicleleasingsolutions.co.uk/ ',
		webLinkText: 'www.jct600vehicleleasingsolutions.co.uk',
		privacyPolicyLink: 'https://jct600vehicleleasingsolutions.co.uk/privacy-statement/',
		footerLogo: {
			display: true,
			image: '/images/themes/jct/logo.png',
		},
		themeText: 'JCT600 VLS',
		bannerColour: '#1C2637',
		displayLoginWelcomeText: true,
	},
	mii: {
		logo: '/images/themes/mii/logo.png',
		webLink: '/',
		webLinkText: 'TBA',
		privacyPolicyLink: '/',
		footerLogo: {
			display: true,
			image: '/images/themes/mii/logo-footer.png',
		},
		themeText: 'Mobility In Insurance',
		bannerColour: '#002357',
		displayLoginWelcomeText: false,
	},
	humberside: {
		logo: '/images/themes/humberside/logo.png',
		webLink: 'https://humbersidefire.gov.uk/ ',
		webLinkText: 'www.humbersidefire.gov.uk',
		privacyPolicyLink: 'https://humbersidefire.gov.uk/privacy-policy/',
		footerLogo: {
			display: true,
			image: '/images/themes/humberside/logo-footer.png',
		},
		themeText: 'Humberside Fire & Rescue Service',
		bannerColour: '#AD1707',
		displayLoginWelcomeText: true,
	},
	novuna: {
		logo: '/images/themes/novuna/logo.png',
		webLink: 'https://www.novuna.co.uk/ ',
		webLinkText: 'www.novuna.co.uk',
		privacyPolicyLink: 'https://www.novuna.co.uk/privacy-policy/',
		footerLogo: {
			display: true,
			image: '/images/themes/novuna/logo-footer.png',
		},
		themeText: 'Novuna',
		bannerColour: '#7D3CFF',
		displayLoginWelcomeText: true,
	},
}

export type ThemeKeys = keyof typeof themeData

export type ThemeDetails = {
	logo: string
	privacyPolicyLink: string
	webLink: string
	webLinkText: string
	footerLogo: { display: boolean; image: string }
	themeText: string
	bannerColour: string
	logoStyles?: React.CSSProperties
	subHeadingStyles?: React.CSSProperties
	displayLoginWelcomeText: boolean
}
